var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpritePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  y: 409,
  viewBox: "-10 -10 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E48",
  d: "m40.848 38.086-1.721 1.721A4.04 4.04 0 0 1 36.249 41a4.04 4.04 0 0 1-2.3-.715c-2.44-1.679-5.715-4.046-7.452-5.782-1.736-1.736-4.102-5.011-5.782-7.453a4.066 4.066 0 0 1 .478-5.177l1.72-1.721a.517.517 0 0 1 .737 0l2.866 2.866a.52.52 0 0 1 0 .736l-1.235 1.235a2.01 2.01 0 0 0-.292 2.476c.703 1.149 2.116 3.308 3.677 4.869s3.72 2.973 4.869 3.677c.317.195.68.297 1.053.297.538 0 1.043-.209 1.423-.59l1.235-1.234a.517.517 0 0 1 .736 0l2.866 2.866a.52.52 0 0 1 0 .736m.707-1.443-2.866-2.866a1.52 1.52 0 0 0-1.075-.445c-.39 0-.778.148-1.075.445l-1.235 1.234a1.01 1.01 0 0 1-1.247.147c-1.077-.659-3.187-2.034-4.684-3.531s-2.872-3.607-3.531-4.684a1.01 1.01 0 0 1 .147-1.247l1.234-1.235a1.52 1.52 0 0 0 0-2.15l-2.866-2.866A1.52 1.52 0 0 0 23.282 19c-.39 0-.778.148-1.075.445l-1.721 1.721a5.06 5.06 0 0 0-.595 6.45c1.745 2.538 4.123 5.818 5.899 7.594s5.056 4.154 7.594 5.899a5.064 5.064 0 0 0 6.45-.595l1.72-1.721a1.52 1.52 0 0 0 0-2.15"
}))));
export default SvgSpritePhone;